import { QueryClient } from "@tanstack/react-query";
import { fetchTourHeaderData } from "@/hooks/product-detail-page/tour-header/use-tour-header";
import { StaticContent } from "@/types/dto/pdp/pdp-contentful";

const prefetchTourHeader = (
  queryClient: QueryClient,
  packageId: string,
  packageDateId: string,
  neoId: string,
  staticContent: StaticContent,
  currencyId: string,
  marketId: string
) => {
  queryClient.prefetchQuery({
    queryKey: ["PDP_TOUR_HEADER", neoId, packageId, packageDateId, currencyId, marketId],
    queryFn: fetchTourHeaderData(packageId, packageDateId, neoId, currencyId, marketId, staticContent as any),
    staleTime: Infinity
  });
};

export default prefetchTourHeader;